module.exports = __webpack_public_path__ + "static/media/footer-naskah.fcc44868.png";